import React from "react";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="es-footer" id="footer" role="contentinfo">
        <div className="es-footer-nonsolus">
          <a
            aria-label="Elsevier homepage"
            className="es-js-tooltip"
            href="https://www.elsevier.com/"
            rel="noopener nofollow"
            target=""
          >
            <img
              alt="Elsevier"
              height="60"
              src="/ElsevierStyleSheet/images/nonsolus-elsevier.svg"
              width="60"
            />
          </a>
        </div>
        <div className="es-footer-content">
          <ul className="es-footer-links">
            <li>
              Copyright © {new Date().getFullYear()}&nbsp;
              Elsevier B.V.
            </li>
            <li>
              <a
                className="es-link"
                href="https://www.elsevier.com/legal/elsevier-website-terms-and-conditions"
                rel="noopener nofollow"
                target=""
              >
                Terms and conditions
              </a>
            </li>
            <li>
              <a
                className="es-link"
                href="https://www.elsevier.com/legal/privacy-policy"
                rel="noopener nofollow"
                target=""
              >
                Privacy policy
              </a>
            </li>
          </ul>
          <div className="es-footer-cookie">
            We use cookies to help provide and enhance our service and tailor
            content. By continuing you agree to the&nbsp;
            {/* <a className="es-link bold" href="#"> */}
              use of cookies
            {/* </a> */}
            .
          </div>
        </div>
        <div className="es-footer-relx">
          <a
            aria-label="RELX ™ homepage"
            className="es-js-tooltip"
            href="https://www.relx.com/"
            rel="noopener nofollow"
            target=""
          >
            <img
              alt="RELX ™"
              height="21"
              src="/ElsevierStyleSheet/images/relx.svg"
              width="90"
            />
          </a>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;